import projects from "../data/projects";

export default function Projects() {
  return (
    <section className="py-20">
      <div className="container-narrow">
        <h1 className="page-heading">Projects</h1>

        <div className="divide-y divide-line">
          {projects.map((proj) => (
            <article key={proj.title} className="py-8 first:pt-0">
              <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1 mb-3">
                <h2 className="font-medium">
                  {proj.title}
                  {proj.event && (
                    <span className="text-muted font-normal"> ({proj.event})</span>
                  )}
                </h2>
                <div className="flex gap-4 text-sm shrink-0">
                  {proj.links.map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-link"
                    >
                      {link.label} ↗
                    </a>
                  ))}
                </div>
              </div>
              <p className="text-sm text-muted leading-relaxed">{proj.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
